SCHEMA_EMARSYS_FIELDS